import React, { useState, useCallback } from "react";
import { formatDayMonth } from "utils/formatDate";
import BanHangApi from "service/QuanLyMuaBan/BanHangApi";
import { pushNotification } from "utils/notifications";
import InDanhSachBanHang from "../BanHang/ChucNang/InDanhSachBanHang"; 

const MenuChucNang = ({ dataSearch, listUserName, btnThemMoiClick, RoleThemMoi }) => {
    const [ListFull, setListFull] = useState([]);
    const [ShowPrint, setShowPrint] = useState(false);
    const [IsPrint, setIsPrint] = useState(null);

    const LoadDataInDanhSachBanHang = useCallback((searchData) => {
        const payload = {
            ...searchData,
            DateFrom: searchData.DateFrom
                ? formatDayMonth(searchData.DateFrom)
                : undefined,
            DateTo: searchData.DateTo
                ? formatDayMonth(searchData.DateTo)
                : undefined,
            pageIndex: -1, 
            pageSize: 0,
        };
        return BanHangApi.getData(payload) 
            .then((res) => {
                if (res.status === 200) {
                    return res.data || { List: [] };
                } else {
                    pushNotification("In danh sách bán hàng thất bại!!", "error", "TOP_CENTER", 2000);
                    return { List: [] };
                }
            })
            .catch((error) => {
                console.error("Lỗi khi gọi Api lấy dữ liệu in danh sách bán hàng:", error);
                pushNotification("Có lỗi xảy ra khi in danh sách bán hàng!", "error", "TOP_CENTER", 2000);
                return { List: [] };
            });
    }, []);

    const btnInDanhSachClick = () => {
        LoadDataInDanhSachBanHang(dataSearch)
            .then((data) => {
                if (data.List && data.List.length > 0) {
                    setListFull(data.List || []);
                    setIsPrint(true);
                    setShowPrint(true);
                } else {
                    pushNotification("Không có dữ liệu in theo điều kiện đang chọn!", "error", "TOP_CENTER", 1000);
                }
            })
            .catch((error) => {
                console.error("Lỗi xử lý sau khi load dữ liệu in:", error);
            });
    };
    
    const ModelClose = () => {
        setIsPrint(null);
        setShowPrint(false);
        setListFull([]);
    }

    return (<>
        <div className="" style={{ display: "flex", justifyContent: "space-between", maxWidth: "100%", margin: "10px" }} >
            <div>
                {RoleThemMoi && (
                <div className="input-sm-new " style={{ maxWidth: "50px", }}>
                    <button type="button" className="btn btn-border-new" onClick={btnThemMoiClick}>
                        <span>
                            <img
                                src="/app-assets/images/icon-them-moi-cam-do-v2.png"
                                style={{ paddingBottom: "5px", marginRight: '6px' }}
                                alt="Thêm mới"
                            />
                            Thêm mới
                        </span>
                    </button>
                </div>
            )}
            </div>
            
            <div className="input-sm-new" style={{ minWidth: "30%", maxWidth: "30%", display: "flex", flexDirection: "row", justifyContent: "flex-end", gap: "10px" }}>
                <a type="button" className="con-bgnew color-print1" onClick={btnInDanhSachClick} title="In danh sách">
                    <img src="/app-assets/images/logo-print-v2.png" alt="In phiếu" />
                </a>
            </div>
        </div>       
        {
            ShowPrint && IsPrint === true &&
            <InDanhSachBanHang
                show={ShowPrint}
                onHide={ModelClose}
                listData={ListFull}
                isPrint={IsPrint}
                listUserName={listUserName}
            />
        }
    </>)
}

export default MenuChucNang;